let legacyMqttSupportEnabled = true

export function isLegacyMqttSupportEnabled() {
  return legacyMqttSupportEnabled
}

export function setLegacyMqttSupportEnabled(value) {
  legacyMqttSupportEnabled = Boolean(value)
}
